import {
  ISSUES_FOR_COLOUR_FAILED,
  ISSUES_FOR_COLOUR_REQUEST,
  ISSUES_FOR_COLOUR_SUCCESS,
} from "../../../../actions/Factory/Colour/issuesForColour/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const issuesForColourReducer = function (
  state = INIT_STATE,
  action
) {
  switch (action?.type) {
    case ISSUES_FOR_COLOUR_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case ISSUES_FOR_COLOUR_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case ISSUES_FOR_COLOUR_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
